var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"star self-center ml-2 mr-4"},[_c('div',{class:['percent', _vm.percent_rate]})]),_c('div',[_vm._v(_vm._s(_vm.number_percent)+" %")])])
}
var staticRenderFns = []

export { render, staticRenderFns }